module.exports = __webpack_public_path__ + "static/media/join-barn-family-one.be1ea32b.png";